module.exports = __webpack_public_path__ + "img/about_local_team_daily01.659b3266.png";